import { AxiosInstance } from 'axios';
import { FinancialAccountReportRequestModel } from './models/FinancialAccountReportRequestModel';
import * as FinancialAccountReportService from './services';

export type FinancialAccountReportServiceType = {
  exportPDF: (payload: FinancialAccountReportRequestModel) => Promise<void>;
};

export const initFinancialAccountReportService = (
  axios: AxiosInstance
): FinancialAccountReportServiceType => ({
  exportPDF: payload => FinancialAccountReportService.exportPDF(axios)(payload),
});
